"use client";
import clsx from "clsx";
import Link from "next/link";
import React, { useContext, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { MenuContext } from "@/components/ui/navigation/mobile-navigation";
import { NavItem } from "@/lib/data";

interface MobileNavigationItemProps {
  href: string;
  displayName: string;
  level?: number;
  subMenu?: NavItem[];
}

const MobileNavigationItem: React.FC<MobileNavigationItemProps> = ({
  href,
  displayName,
  subMenu,
  level = 0,
}) => {
  const withSubmenu = subMenu && subMenu.length > 0;
  const { closeMenu } = useContext(MenuContext);

  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const toggleSubMenu: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    if (withSubmenu) {
      setSubMenuOpen(!subMenuOpen);
    }
  };

  return (
    <li className="cursor-pointer font-roboto">
      <div
        className={clsx(
          "flex w-full flex-row items-stretch justify-between text-body-1-300 text-neutral-600 transition-colors hover:bg-primary-200 hover:text-body-1-400 hover:text-primary-600 focus:bg-primary-200 focus:text-body-1-400 focus:text-primary-600",
          subMenuOpen && "bg-primary-100 !text-body-1-400 text-primary-600",
          level > 1 && "bg-neutral-100"
        )}
        style={{ paddingLeft: `${level * 1 + 1}rem` }}
      >
        {/* TODO: Use withURL on this one--note that this breaks tests! */}
        <Link
          href={href}
          onClick={closeMenu}
          className="flex-1 py-2 pr-2 text-left"
        >
          {displayName}
        </Link>
        {withSubmenu && (
          <button
            className="flex w-8 items-center justify-center"
            onClick={toggleSubMenu}
            aria-label={`${!subMenuOpen ? "open" : "close"} ${displayName} submenu`}
          >
            <FaChevronDown
              className={clsx([
                "z-10 select-none transition-transform",
                { "-scale-y-100": subMenuOpen },
              ])}
            />
          </button>
        )}
      </div>
      {/* Render submenus recursively */}
      {withSubmenu && subMenuOpen && (
        <ul className="flex flex-col">
          {subMenu.map((subMenuItem) => (
            <MobileNavigationItem
              key={subMenuItem.nest + "-" + subMenuItem.href}
              href={subMenuItem.href}
              displayName={subMenuItem.displayName}
              subMenu={subMenuItem.subMenu}
              level={level + 1}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MobileNavigationItem;
